module.exports = __webpack_public_path__ + "static/media/9DESA7.7c2c2453.jpg";